import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrandPLPComponent } from './components';

const routes: Routes = [{ path: ':slug', component: BrandPLPComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BrandPLPRoutingModule {}
